import { logger } from '@gem/modules/logger';

import { updateOldOrFakeMessages } from 'APP/Tasks/messaging/updateOldOrFakeMessages/updateOldOrFakeMessages';
import loadUnknownDataFromMessages from 'APP/Tasks/relationships/loadUnknownDataFromMessages';
import { IGetMessageRequest, IMessage } from 'APP/model/message/messageModel.types';
import { messageModel } from 'APP/model/model';
import Entities from 'STORE';

async function getMessages(data: IGetMessageRequest): Promise<IMessage[]> {
  try {
    const response = await messageModel.getRangeAroundMessage(data);

    return response.messages;
  } catch (error) {
    logger.get('API').error('messaging.getRangeAroundMessage', error);
  }

  return [];
}

export const loadRangeAroundMessages = async ({
  groupId,
  messageId,
  halfLimit,
}: IGetMessageRequest): Promise<IMessage[]> => {
  const group = Entities.GroupsStore.getGroupById(groupId);
  if (!group) {
    return [];
  }

  group.messagesStore.setIsLoadingMessages(true);

  const messages = await getMessages({ groupId, messageId, halfLimit });
  await loadUnknownDataFromMessages({ messages });

  updateOldOrFakeMessages({ messages, groupId });

  group.messagesStore.setIsLoadingMessages(false);

  return messages;
};
